<template>
    <el-dialog :title="titleDialog" :visible="showDialog" @close="close" @open="create">
        <form autocomplete="off" @submit.prevent="submit">
            <div class="form-body">
                <!-- <div class="col-md-12 text-right">
                    <h5>Cant. Pedida: {{quantity}}</h5>
                    <h5 v-bind:class="{ 'text-danger': (toAttend < 0) }">Por Atender: {{toAttend}}</h5>
                </div> -->
                <div class="row mb-3">
                    <div class="col-12 text-right">
                        <el-checkbox v-model="form.has_igv"
                            :disabled="recordId === 1"
                        >Incluye Igv</el-checkbox>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-6">
                        <div class="form-group" :class="{'has-danger': errors.name}">
                            <label class="control-label">Nombre</label>
                            <el-input v-model="form.name"
                                :disabled="recordId === 1"
                            ></el-input>
                            <small class="form-control-feedback" v-if="errors.name" v-text="errors.name[0]"></small>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-group" :class="{'has-danger': errors.pricing}">
                            <label class="control-label">Precio</label>
                            <el-input v-model="form.pricing"
                                :disabled="recordId === 1"
                            ></el-input>
                            <small class="form-control-feedback" v-if="errors.pricing" v-text="errors.pricing[0]"></small>
                        </div>
                    </div>
                </div>
                <div class="row mb-3">
                    <div class="col-md-6">
                        <div class="form-group" :class="{'has-danger': errors.limit_users || errorLUser.limit_users}">
                            <label class="control-label">Límite de usuarios</label>
                            <el-input v-model="limit_users" @input="validateLUsers"  :disabled="users_unlimited"></el-input>
                            <el-checkbox v-model="users_unlimited" @change="setUnlimitUsers"
                                :disabled="recordId === 1"
                            >Ilimitado</el-checkbox><br>
                            <small class="form-control-feedback d-block" v-if="errors.limit_users" v-text="errors.limit_users[0]"></small>
                            <small class="form-control-feedback" v-if="errorLUser.limit_users" v-text="errorLUser.limit_users[0]"></small> 
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-group" :class="{'has-danger': errors.limit_documents || errorLDocument.limit_documents}">
                            <label class="control-label">Límite de documentos
                                <el-tooltip class="item"
                                            :content="form.include_sale_notes_limit_documents ? 'Cantidad factura, boleta, nota de crédito, nota de débito y nota de venta' : 'Cantidad factura, boleta, nota de crédito y débito'"
                                            effect="dark"
                                            placement="top">
                                    <i class="fa fa-info-circle"></i>
                                </el-tooltip>
                            </label>
                            <el-input v-model="limit_documents" @input="validateLDocuments" :disabled="documents_unlimited"></el-input>
                            <el-checkbox v-model="documents_unlimited" @change="setUnlimitDocuments"
                                :disabled="recordId === 1"
                            >Ilimitado</el-checkbox><br>

                            <el-checkbox v-model="form.include_sale_notes_limit_documents"
                                :disabled="recordId === 1"
                            >Incluir notas de venta</el-checkbox><br>

                            <small class="form-control-feedback d-block" v-if="errors.limit_documents" v-text="errors.limit_documents[0]"></small>
                            <small class="form-control-feedback" v-if="errorLDocument.limit_documents" v-text="errorLDocument.limit_documents[0]"></small>
                        </div>
                    </div>

                    <div class="col-md-6">
                        <div class="form-group" :class="{'has-danger': errors.establishments_limit}">
                            <label class="control-label">Límite de establecimientos</label>

                            <template v-if="form.establishments_unlimited">
                                <el-input value="∞" disabled></el-input>
                            </template>
                            <template v-else>
                                <el-input v-model="form.establishments_limit"
                                    :disabled="recordId === 1"
                                ></el-input>
                            </template>

                            <el-checkbox v-model="form.establishments_unlimited"
                                :disabled="recordId === 1"
                            >Ilimitado</el-checkbox><br>

                            <small class="form-control-feedback d-block" v-if="errors.establishments_limit" v-text="errors.establishments_limit[0]"></small>
                        </div>
                    </div>

                    
                    <div class="col-md-6">
                        <div class="form-group" :class="{'has-danger': errors.sales_limit}">
                            <label class="control-label">
                                Límite de ventas mensual
                                <el-tooltip class="item"
                                            :content="form.include_sale_notes_sales_limit ? 'Monto (S/.) factura, boleta, nota de crédito, nota de débito y nota de venta' : 'Monto (S/.) factura, boleta, nota de crédito y débito'"
                                            effect="dark"
                                            placement="top">
                                    <i class="fa fa-info-circle"></i>
                                </el-tooltip>
                            </label>

                            <template v-if="form.sales_unlimited">
                                <el-input value="∞" disabled></el-input>
                            </template>
                            <template v-else>
                                <el-input v-model="form.sales_limit"
                                    :disabled="recordId === 1"
                                ></el-input>
                            </template>

                            <el-checkbox v-model="form.sales_unlimited"
                                :disabled="recordId === 1"
                            >Ilimitado</el-checkbox><br>
                            <el-checkbox v-model="form.include_sale_notes_sales_limit"
                                :disabled="recordId === 1"
                            >Incluir notas de venta</el-checkbox><br>


                            <small class="form-control-feedback d-block" v-if="errors.sales_limit" v-text="errors.sales_limit[0]"></small>
                        </div>
                    </div>

                    <div class="col-md-6">
                        <div class="form-group"
                            :class="{ 'has-danger' : errors.period_id }"
                        >
                            <label class="control-label">
                                Periodo
                            </label>
                            <el-select v-model="form.period_id" placeholder="Seleccione un periodo"
                                :disabled="recordId === 1"
                            >
                              <el-option v-for="(period, index) in periods"
                                :key="index"
                                :label="period.name"
                                :value="period.id"
                              ></el-option>
                            </el-select>
                            <small v-if="errors.period_id"
                                class="form-control-feedback d-block"
                                v-text="errors.period_id[0]"
                            ></small>
                        </div>
                    </div>
                    <div class="col-md-6" >
                        <div class="form-group" v-if="form.period_id">
                            <label class="control-label">Cant. de Meses</label>
                            <template v-for="(period, index) in periods"
                                v-if="period.id === form.period_id">
                                <el-input :value="period.number_months" disabled></el-input>
                            </template>                            
                        </div>
                    </div>
                </div>
                
                <el-collapse v-model="panelActive">
                    <el-collapse-item title="Módulos">
                        <div class="row">
                            <span class="ml-4">Giro de negocio <small>(opcional)</small></span>
                            <div class="col-12">
                                <el-radio-group v-model="business" @change="changeModules"
                                    :disabled="recordId === 1"
                                >
                                    <el-radio :label="1">Básico</el-radio>
                                    <el-radio :label="2">Farmacia</el-radio>
                                    <el-radio :label="3">Hotel</el-radio>
                                    <el-radio :label="4">Restaurante</el-radio>
                                </el-radio-group>
                            </div>
                            <div class="col-md-6">
                                <span>
                                    Habilitar módulos
                                </span>
                                <div class="form-group tree-container-admin">
                                    <el-tree
                                        ref="tree"
                                        :check-strictly="true"
                                        :data="modules"
                                        :props="defaultProps"
                                        accordion
                                        highlight-current
                                        node-key="id"
                                        show-checkbox
                                        @check="FixChildren">
                                    </el-tree>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <span>
                                    Habilitar apps
                                </span>
                                <div class="form-group tree-container-admin">
                                    <el-tree
                                        ref="Apptree"
                                        :check-strictly="true"
                                        :data="apps"
                                        :props="defaultAppsProps"
                                        accordion
                                        highlight-current
                                        node-key="id"
                                        show-checkbox
                                        @check="FixAppChildren">
                                    </el-tree>
                                </div>
                            </div>
                        </div>
                    </el-collapse-item>
                </el-collapse>
            </div>
            <div class="form-actions text-right pt-2">
                <el-button @click.prevent="close()">Cancelar</el-button>
                <el-button type="primary" native-type="submit" :loading="loading_submit" v-if="recordId !== 1">Guardar</el-button>
            </div>
        </form>
    </el-dialog>
</template>

<style>
.plan_documents{ display:block ; margin: 15px 0 ;}
</style>

<script>

    export default {
        props: ['showDialog', 'recordId','plan_documents'],
        data() {
            return {
                loading_submit: false,
                titleDialog: null,
                resource: 'plans',
                documents_unlimited:null,
                users_unlimited:null,
                limit_users:null,
                limit_documents:null,
                errors: {},
                errorLDocument:{},
                errorLUser:{},
                form: {},
                panelActive: 1,
                business: null,
                modules: [],
                defaultProps: {
                    children: 'childrens',
                    label: 'description',
                    disabled: 'disabled'
                },
                apps: [],
                defaultAppsProps: {
                    children: 'childrens',
                    label: 'description',
                    disabled: 'disabled'
                },
                periods: []
            }
        },
        created() 
        {
            this.initForm() 
        },
        methods: {
            FixChildren(currentObj, treeStatus) {
                let element = this.$refs.tree
                if (currentObj !== undefined) {
                    let selected = treeStatus.checkedKeys.indexOf(currentObj.id) // -1 is unchecked
                    if (selected !== -1) {
                        this.SelectParent(currentObj, element)
                        this.FixSameValueToChild(currentObj, true, element)
                    } else {
                        if (currentObj.childrens !== undefined && currentObj.childrens.length !== 0) {
                            this.FixSameValueToChild(currentObj, false, element)
                        }
                    }
                }
            },
            FixAppChildren(currentObj, treeStatus) {
                let element = this.$refs.Apptree
                if (currentObj !== undefined) {
                    let selected = treeStatus.checkedKeys.indexOf(currentObj.id) // -1 is unchecked
                    if (selected !== -1) {
                        this.SelectParent(currentObj, element)
                        this.FixSameValueToChild(currentObj, true, element)
                    } else {
                        if (currentObj.childrens !== undefined && currentObj.childrens.length !== 0) {
                            this.FixSameValueToChild(currentObj, false, element)
                        }
                    }
                }
            },
            FixSameValueToChild(treeList, isSelected, element) {
                // console.dir(element);
                if (treeList !== undefined && element !== undefined) {
                    element.setChecked(treeList.id, isSelected)
                    if (treeList.childrens !== undefined) {
                        for (let i = 0; i < treeList.childrens.length; i++) {
                            this.FixSameValueToChild(treeList.childrens[i], isSelected, element)
                        }
                    }
                }
            },
            SelectParent(currentObj, element) {
                // console.error(element);
                if (currentObj !== undefined) {
                    let currentNode = element.getNode(currentObj)
                    if (currentNode.parent.key !== undefined) {
                        element.setChecked(currentNode.parent, true)
                        this.SelectParent(currentNode.parent, element)
                    }
                }
            },
            notEmpty(value)
            {
                return !_.isEmpty(value)
            },
            initForm() {
                this.limit_users = null
                this.limit_documents = null
                this.documents_unlimited = false
                this.users_unlimited = false
                this.errors = {}
                this.errorLDocument = {}
                this.errorLUser = {}
                
                this.form = {
                    id: null,
                    name: null,
                    pricing: null,
                    limit_users: null,
                    limit_documents: null,
                    plan_documents:[],

                    establishments_limit : 0,
                    establishments_unlimited : true,

                    sales_limit : 0,
                    sales_unlimited : true,
                    include_sale_notes_sales_limit : false,
                    include_sale_notes_limit_documents: false,
                    modules: [],
                    levels: [],
                    period_id: null,
                    has_igv: false
                }

            },
            async create() {
                try {
                    const response = await this.$http.get(`/plans/data-modules`)
                    const { data } = response
                    this.modules = data.modules
                    this.apps = data.apps
                    this.group_basic = data.group_basic
                    this.group_hotel = data.group_hotel
                    this.group_pharmacy = data.group_pharmacy
                    this.group_restaurant = data.group_restaurant
                    this.group_hotel_apps = data.group_hotel_apps
                    this.group_pharmacy_apps = data.group_pharmacy_apps
                    this.group_restaurant_apps = data.group_restaurant_apps
                    this.group_golden_default = data.group_golden_default
                    this.apps_golden_default = data.apps_golden_default
                    this.periods = data.periods

                    let selected = []
                    let selectedApps = []
                    this.modules.forEach(element => {
                        selected.push(element.id)
                        element.childrens.forEach(children => {
                            selected.push(children.id)
                        })
                    })
                    this.apps.forEach(element => {
                        selectedApps.push(element.id)
                        element.childrens.forEach(children => {
                            selectedApps.push(children.id)
                        })
                    })
                    this.$refs.tree.setCheckedKeys(selected)
                    this.$refs.Apptree.setCheckedKeys(selectedApps)
                } catch (error) {
                    console.log(error)
                }

                this.titleDialog = (this.recordId)? 'Editar plan':'Nuevo plan'
                if (this.recordId) {
                    this.$http.get(`/${this.resource}/record/${this.recordId}`).then(response => {
                            this.setData(response.data.data)
                        })
                        .catch(error => {
                            if (error.response) {
                                let message = error.response.data.message || 'Ocurrio un error inesperado'
                                this.$message.error(message)
                            }
                        })
                }
            },
            validateInputs()
            {
                if(!this.form.establishments_unlimited)
                {
                    if(isNaN(this.form.establishments_limit)) return this.getResponseValidations(false, 'Límite de establecimientos no es un número válido.')
                } 

                if(!this.form.sales_unlimited)
                {
                    if(isNaN(this.form.sales_limit)) return this.getResponseValidations(false, 'Límite de ventas no es un número válido.')
                } 

                return this.getResponseValidations()
            },
            submit() {   

                if(this.validateLUsers().limit_users || this.validateLDocuments().limit_documents)
                    return
                    
                const validate_inputs = this.validateInputs()
                if(!validate_inputs.success) return this.$message.error(validate_inputs.message)
                
                this.transform()
                this.setDataModules()

                if (!this.form.modules.length) {
                    this.$message.error('Debe seleccionar al menos un modulo.')
                    return
                }
                
                this.loading_submit = true  
                this.$http.post(`${this.resource}`, this.form)
                    .then(response => {
                        if (response.data.success) {
                            this.$message.success(response.data.message)
                            this.$eventHub.$emit('reloadData')
                            this.close()
                        } else {
                            this.$message.error(response.data.message)
                        }
                    })
                    .catch(error => {
                        if (error.response.status === 422) {
                            this.errors = error.response.data 
                        } else {
                            console.log(error.response)
                            if (error.response) {
                                let message = error.response.data.message || 'Ocurrio un error inesperado'
                                this.$message.error(message)
                            }
                        }
                    })
                    .then(() => {
                        this.loading_submit = false
                    })
                    
            },
            setData(data){

                this.form = data
                this.form.plan_documents = Object.values(data.plan_documents)
                this.users_unlimited = (data.limit_users == 0 || this.recordId === 1) ? true : false
                this.documents_unlimited = (data.limit_documents == 0) ? true : false                
                this.limit_users = (this.users_unlimited) ? "∞": data.limit_users
                this.limit_documents = (this.documents_unlimited) ? "∞":  data.limit_documents
                let modules = []
                let apps = []
                data.modules.forEach(module => {
                    if (module.sort < 14) {
                        modules.push(module.module_id)
                    } else {
                        apps.push(module.module_id)
                    }
                })
                data.levels.map(level => {
                    if (level.sort_module < 14) {
                        modules.push(level.full_id)
                    } else {
                        apps.push(level.full_id)
                    }
                })
                
                this.$refs.tree.setCheckedKeys(modules)
                this.$refs.Apptree.setCheckedKeys(apps)

                if (this.recordId === 1) {
                    const tmp_modules = this.modules
                    const tmp_apps = this.apps


                    this.modules = tmp_modules.map(m => {
                        return {
                            ...m,
                            disabled: true,
                            childrens: m.childrens.map(c => {
                                return {
                                    ...c,
                                    disabled: true
                                }
                            })
                        }
                    })
                    this.apps = tmp_apps.map(m => {
                        return {
                            ...m,
                            disabled: true,
                            childrens: m.childrens.map(c => {
                                return {
                                    ...c,
                                    disabled: true
                                }
                            })
                        }
                    })
                }
            },
            transform(){

                if(this.users_unlimited){
                    this.form.limit_users = 0
                }else{
                    this.form.limit_users = this.limit_users
                }

                if(this.documents_unlimited){
                    this.form.limit_documents = 0
                }else{
                    this.form.limit_documents = this.limit_documents
                }
                
            },
            validateLDocuments(){

                this.errorLDocument = {} 

                if(!this.documents_unlimited){
                    if(this.limit_documents < 1)
                        this.$set(this.errorLDocument, 'limit_documents', ['limite de documentos debe ser mayor a cero']);
                } 

                return this.errorLDocument 
            },            
            
            validateLUsers(){

                this.errorLUser = {}  
                 
                if(!this.users_unlimited){
                    if(this.limit_users < 1)
                        this.$set(this.errorLUser, 'limit_users', ['limite de usuarios debe ser mayor a cero']);
                }

                return this.errorLUser 
            },            
            setUnlimitDocuments(){
                this.limit_documents = (this.documents_unlimited) ? "∞" : null
                this.form.limit_documents = (this.limit_documents == "∞") ? 0 : this.limit_documents
            },
            setUnlimitUsers(){
                this.limit_users = (this.users_unlimited) ? "∞" : null
                this.form.limit_users = (this.limit_users == "∞") ? 0 : this.limit_users

            },
            close() {
                this.$emit('update:showDialog', false)
                this.initForm()
            },

            changeModules() {
                var group = {
                    modules: [],
                    apps: [],
                };
                if(this.business == 1){
                    group.modules = this.getIds(this.group_basic);
                }
                if(this.business == 2){
                    group.modules = this.getIds(this.group_pharmacy);
                    group.apps = this.getIds(this.group_pharmacy_apps);
                }
                if(this.business == 3){
                    group.modules = this.getIds(this.group_hotel);
                    group.apps = this.getIds(this.group_hotel_apps);
                }
                if(this.business == 4){
                    group.modules = this.getIds(this.group_restaurant);
                    group.apps = this.getIds(this.group_restaurant_apps);
                }
                this.$refs.tree.setCheckedKeys(group.modules);
                this.$refs.Apptree.setCheckedKeys(group.apps);
            },
            getIds(modules) {
                const preSelecteds = [];
                modules.map(m => {
                    preSelecteds.push(m.id);
                    m.childrens.map(c => {
                        preSelecteds.push(c.id);
                    });
                });
                return preSelecteds
            },
            setDataModules() {
                const modulesSelected = this.$refs.tree.getCheckedNodes()
                const appsSelected = this.$refs.Apptree.getCheckedNodes()
                const modules = []
                const levels = []
                modulesSelected.forEach(module => {
                    if (module.is_parent) {
                        modules.push(module.id)
                    }
                })
                appsSelected.forEach(app => {
                    if (app.is_parent) {
                        modules.push(app.id)
                    }
                })
                modulesSelected.forEach(module => {
                    if (!module.is_parent) {
                        const id = module.id.split('-')
                        levels.push(id[1])
                    }
                })
                appsSelected.forEach(module => {
                    if (!module.is_parent) {
                        const id = module.id.split('-')
                        levels.push(id[1])
                    }
                })
                this.form.modules = modules
                this.form.levels = levels
            }
        }
    }
</script>


// WEBPACK FOOTER //
// resources/js/views/system/plans/form.vue